import { Routes } from "@angular/router";

import { AdminLayoutComponent } from "./layouts/admin/admin-layout.component";
import { CamLoginComponent } from "./cam-login/cam-login.component";

import { Dashboard3Component } from "./camera-config/dashboard3/dashboard3.component";

export const AppRoutes: Routes = [
  { path: "", redirectTo: "cameraLogin", pathMatch: "full" },
  {
    path: "",
    component: AdminLayoutComponent,
    loadChildren:
          "./camera-config/camera-config.module.ts#CameraConfigModule",
  },

  { path: "cameraLogin", component: CamLoginComponent },
  {
    path: "outdashboard",
    component: Dashboard3Component,
    data: {
      breadcrumb: "ข้อมูลรถ (Realtime)",
      status: true,
    },
  },
  {
    path: "**",
    redirectTo: "error/404",
  },
];



// WEBPACK FOOTER //
// E:/Git_new/IVMS_PRO/web/src/app/app.routing.ts